/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ occasions: NonNullable<unknown> }} Goodforguestspending3Inputs */

const en_goodforguestspending3 = /** @type {(inputs: Goodforguestspending3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Not enough votes yet: ${i?.occasions}`)
};

const de_goodforguestspending3 = /** @type {(inputs: Goodforguestspending3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Noch zu wenige Stimmen: ${i?.occasions}`)
};

/**
* | output |
* | --- |
* | "Not enough votes yet: {occasions}" |
*
* @param {Goodforguestspending3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const goodforguestspending3 = /** @type {((inputs: Goodforguestspending3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Goodforguestspending3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_goodforguestspending3(inputs)
	return de_goodforguestspending3(inputs)
});
export { goodforguestspending3 as "goodForGuestsPending" }